// <s-card-swatches> swaps a product card's first photo to the chosen color's
// variant photo (hover on a fine pointer, click/tap everywhere) and points the
// card's links at that variant.
class SCardSwatches extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const signal = this.#ac.signal;
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    this.querySelectorAll('[data-swatch]').forEach((swatch) => {
      swatch.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.#select(swatch);
      }, { signal });
      swatch.addEventListener('pointerenter', (event) => {
        if (finePointer.matches && event.pointerType === 'mouse') this.#select(swatch);
      }, { signal });
    });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #select(swatch) {
    const card = this.closest('article');
    if (!card) return;

    this.querySelectorAll('[data-swatch]').forEach((other) => {
      other.setAttribute('aria-pressed', String(other === swatch));
    });

    const track = card.querySelector('[data-gallery-track]');
    const image = track?.querySelector('img');
    if (image && swatch.dataset.src) {
      image.loading = 'eager';
      image.srcset = swatch.dataset.srcset || '';
      image.src = swatch.dataset.src;
      track.scrollTo({ left: 0, behavior: 'instant' });
      card.querySelectorAll('[data-gallery-dot]').forEach((dot, i) => {
        if (i === 0) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    const url = swatch.dataset.url;
    if (url) {
      card.querySelectorAll('a[href]').forEach((link) => {
        if (!link.dataset.baseHref) link.dataset.baseHref = link.getAttribute('href');
        link.setAttribute('href', url);
      });
    }
  }
}

if (!customElements.get('s-card-swatches')) customElements.define('s-card-swatches', SCardSwatches);
